import React from 'react'
import styled from 'styled-components'
import { MqDesktop } from 'streamr-ui/css/consts'

import SelectChain from './SelectChain'

const Container = styled.div`
    background: #ffffff;
    border-radius: 8px;
    box-shadow: 0px 6.30704px 50px -6.30704px rgba(0, 0, 0, 0.1);
    padding: 28px 40px;

    @media ${MqDesktop} {
        padding: 56px 80px;
    }
`

const Heading = styled.h3`
    font-style: normal;
    font-weight: 500;
    font-size: 26px;
    line-height: 32px;
    color: #0c009a;
`

const UnstyledAddTokensAndChains = (props) => (
    <Container {...props}>
        <Heading>Add DATA to your wallet</Heading>
        <SelectChain />
    </Container>
)

const AddTokensAndChains = styled(UnstyledAddTokensAndChains)``

export default AddTokensAndChains
